import {
    appendParameters,
    axiosPlatform,
    prepareAxiosPlatform,
    supportPlatformResponse,
    supportTracing,
} from "../_services/axios-helper";

const getResponseNotification = (notificationUUID) => {
    return axiosPlatform().get("/notification/private/" + notificationUUID);
};

const getPublicResponseNotification = (notificationUUID) => {
    return supportTracing(supportPlatformResponse(prepareAxiosPlatform())).get(
        "/notification/public/" + notificationUUID
    );
};

const getPlatformNotifications = (params) => {
    return axiosPlatform().get(appendParameters("/notification", params));
};

const dismissPlatformNotification = (notificationUUID) => {
    return axiosPlatform().post("/notification/" + notificationUUID + "/dismiss");
};

export const notificationService = {
    getResponseNotification,
    getPublicResponseNotification,
    getPlatformNotifications,
    dismissPlatformNotification,
};
